import * as React from 'react';
import { RenderHtml as RenderHtmlLibby } from '@wix/answers-ui-libby';
import { isFeatureEnabled } from '@wix/answers-experiments';
export var RenderHtml = function (props) {
    var maybeDisableSanitation = !isFeatureEnabled('UseLibbyRenderHtmlInArticleViewer') || props.dangerouslyDisableSanitation ? 'i-know-what-i-am-doing' : undefined;
    return (React.createElement(RenderHtmlLibby, { html: props.html, className: props.className, allowedCustomTags: ['iframe'], allowedCustomAttributes: ['style'], useDiv: props.useDiv, dangerouslyDisableSanitation: maybeDisableSanitation }));
};
//# sourceMappingURL=render-html.comp.js.map